import { BackHandler } from "react-native";
import { useEffect } from "react"
import { useNavigation } from "@react-navigation/native";

const useBackHandler = () => {
	const navigation = useNavigation();

	useEffect(() => {
		const backHandler = BackHandler.addEventListener('hardwareBackPress', () => {
			navigation.goBack()
			return true
		});
		return () => backHandler?.remove()
	}, [navigation])

	return null;
}

export default useBackHandler